import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import state from './state'
import modules from './vuex-modules'

const store = new Vuex.Store({
  state,
  plugins: [createPersistedState()],
  modules
})

export default store




// WEBPACK FOOTER //
// ./client/store/index.js